<template>
  <div v-if="userLocation">
    <google-marker
      v-if="locationDetected"
      :position="userLocation"
      :clickable="false"
      :draggable="false"
      :icon="{
        url: circle,
        size: { width: 16, height: 16 },
        anchor: { x: 8, y: 8 }
      }"
    ></google-marker>

    <google-circle
      :center="userLocation"
      :clickable="false"
      :draggable="false"
      :options="{
        fillColor: '#448AFF',
        fillOpacity: 0.25,
        strokeColor: '#448AFF',
        strokeOpacity: 0.5,
        strokeWeight: 1
      }"
      :radius="locationInaccurate ? userLocation.acc : 0"
    >
    </google-circle>
  </div>
</template>

<script>
import UserCircle from "../assets/user-circle.svg"
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      circle: UserCircle
    }
  },

  computed: {
    ...mapGetters("map", [
      "userLocation",
      "locationDetected",
      "locationInaccurate"
    ])
  }
}
</script>

<style></style>
